import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const Benefit = async () => {
  try {
    return await getData(`/website/subsidypolicy/benefit`);
  } catch (error) {
    console.log(error);
  }
};

export const NewUpdates = async () => {
  try {
    return await getData(`/website/subsidypolicy/newupdate`);
  } catch (error) {
    console.log(error);
  }
};

export const LatestAnnouncements = async () => {
  try {
    return await getData(`/website/subsidypolicy/latestannouncement`);
  } catch (error) {
    console.log(error);
  }
};


export const Electricitys = async () => {
  try {
    return await getData(`/website/subsidypolicy/electricity`);
  } catch (error) {
    console.log(error);
  }
};


export const RooftopSolars = async () => {
  try {
    return await getData(`/website/subsidypolicy/rooftopsolar`);
  } catch (error) {
    console.log(error);
  }
};


export const SubsidyBanners = async () => {
  try {
    return await getData(`/website/subsidypolicy/banner`);
  } catch (error) {
    console.log(error);
  }
};


export const Registrations = async () => {
  try {
    return await getData(`/website/subsidypolicy/registration`);
  } catch (error) {
    console.log(error);
  }
};